import React, { useState } from "react";
import { Button, Form, Input, message, Modal, Radio } from "antd";
import ButtonRow from "components/common/ButtonRow";
import displayErrorNotification from "utils/displayErrorNotification";
import { uploadResume } from "api/resumeApi";
import ResumeFileUpload from "./ResumeFileUpload";

type ResumeUploadModalProps = {
  modalState: boolean;
  employeeId: number;
  refresh: () => void;
  closeModal: () => void;
};

const ResumeUploadModal = ({
                             modalState,
                             employeeId,
                             refresh,
                             closeModal
                           }: ResumeUploadModalProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [comment, setComment] = useState("");
  const [uploading, setUploading] = useState(false);
  const [type, setType] = useState<"Resume" | "Bio" | "Other">("Resume");


  const handleSave = async () => {
    if (!selectedFile) {
      message.error("Please select a resume file");
      return;
    }

    setUploading(true);
    try {
      await uploadResume(
        employeeId,
        selectedFile,
        type,
        comment
      );

      message.success("Resume uploaded successfully!");
      setSelectedFile(null);
      setComment("");
      closeModal();
      refresh();
    } catch (error) {
      displayErrorNotification(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal
      title="Upload Resume"
      visible={modalState}
      onCancel={closeModal}
      footer={null}
    >
      <Form.Item label="Upload Resume">
        <ResumeFileUpload
          maxSize={10 * 1024 * 1024}   // 10 MB
          onFileSelect={setSelectedFile}
          disabled={uploading}
        />

      </Form.Item>

      <Form.Item label="Comment">
        <Input.TextArea
          value={comment}
          onChange={e => setComment(e.target.value)}
          rows={4}
          placeholder="Enter any comments about this resume..."
        />
      </Form.Item>

      <Form.Item label="Type">
        <Radio.Group
          value={type}
          onChange={e => setType(e.target.value)}
        >
          <Radio value="Resume">Resume</Radio>
          <Radio value="Bio">Bio</Radio>
          <Radio value="Other">Other</Radio>
        </Radio.Group>
      </Form.Item>


      <ButtonRow style={{marginTop: "1em"}}>
        <Button
          type="primary"
          onClick={handleSave}
          loading={uploading}
          disabled={!selectedFile}
        >
          Save
        </Button>
        <Button onClick={closeModal} disabled={uploading}>
          Cancel
        </Button>
      </ButtonRow>
    </Modal>
  );
};

export default ResumeUploadModal;
